import apiClient  from '../../../../../services/apiClient';

const API_BASE = 'visits';

export const visitService = {
  async getSchedule(kgId) {
    if (!kgId) throw new Error('kg_id not defined');
    return apiClient.get(`${API_BASE}/scheduler?kindergarten_id=${kgId}`);
  },

  async saveSchedule(kgId, data) {
    if (!kgId) throw new Error('kg_id not defined');
    return apiClient.post(`${API_BASE}/scheduler?kindergarten_id=${kgId}`, data);
  },

  async getVisitsList(kgId, dateFrom, dateTo) {
    if (!kgId) throw new Error('kg_id not defined');
    const url = `${API_BASE}/list?kindergarten_id=${kgId}&date_from=${dateFrom.toISOString()}&date_to=${dateTo.toISOString()}`;
    return apiClient.get(url);
  },

  async updateVisit(kgId, date, event, text) {
    const url = `visitskg/visit`;
    return apiClient.put(url, { date, kg_id: kgId, event, text });
  }
};